import React from "react";
import {
  FaFacebookF,
  FaGithub,
  FaInstagram,
  FaLinkedinIn,
  FaSkype,
  FaTwitter,
} from "react-icons/fa";
import profile from "../../../images/profile.JPG";

const socials = [
  {
    id: 1,
    icon: <FaFacebookF />,
    link: "#0",
  },
  {
    id: 2,
    icon: <FaGithub />,
    link: "https://github.com/SuganDevp",
  },
  {
    id: 3,
    icon: <FaLinkedinIn />,
    link: "https://www.linkedin.com/in/suganpandurengan",
  },
  {
    id: 4,
    icon: <FaInstagram />,
    link: "https://www.instagram.com/__sugan_pandurengan/profilecard/?igsh=ZHI5MHlhZG8xejhh",
  },
  {
    id: 7,
    icon: <FaSkype />,
    link: "https://join.skype.com/invite/rOrHZiIaBEU9",
  },
  {
    id: 7,
    icon: <FaTwitter />,
    link: "https://twitter.com/suganchamp",
  },
];

const Sidebar = () => {
  return (
    <aside className="sticky top-0 bg-white md:mx-8 lg:mx-4 mb-8 p-6 shadow-md rounded-md -mt-40">
      <div className="w-24 h-24 rounded-md overflow-hidden mx-auto mb-5">
        <img src={profile} alt="shafiqhammad" className="w-full" />
      </div>
      <div className="text-center">
        <h1 className="text-xl text-gray-800 font-bold mb-1">Sugan Pandurengan</h1>
        <p className="text-sm text-gray-400 mb-3">
          Project Manager at
          <a href="https://thetopclassentertainment.com/" target="_blank" className="text-purple-600 pl-1" rel="noreferrer">
            Top Class Entertainment
          </a>
        </p>
        <a
          href="https://drive.google.com/u/0/uc?id=1_6p57vR-FkOX_EttIN5AD_jSpXOHxBiL&export=download"
          className="inline-block mb-3 rounded bg-purple-600 text-center border-0 py-2 px-6 text-white leading-7 tracking-wide hover:bg-purple-800"
          download="Resume"
        >
          Download Resume
        </a>
        <ul className="flex flex-wrap justify-center">
          {socials.map((social, id) => (
            <SocialIcon social={social} key={id} />
          ))}
        </ul>
      </div>
      <div className="text-start pt-4">
        <h3 className="text-md mb-2 uppercase font-medium text-gray-800">
          About Me
        </h3>
        <p className="text-gray-400 text font-light leading-relaxed">
          I am a dedicated and detail-oriented professional with 4+ years
          of experience in mobile and web application development.
          Specializing in cross-platform solutions using Flutter,
          I have a strong background in backend integration,
          state management, and advanced features like image
          processing and AI-driven technologies. My expertise
          spans across modern tools and frameworks, including
          Firebase, Node.js, TypeScript, MongoDB, and AWS services
          like Amplify and S3.
        </p>
      </div>
    </aside>
  );
};

export default Sidebar;

const SocialIcon = (props) => {
  const { icon, link } = props.social;
  return (
    <li className="m-2">
      <a
        href={link}
        className="w-8 h-8 bg-purple-100 rounded text-purple-800 flex items-center justify-center hover:text-white hover:bg-purple-600"
      >
        {icon}
      </a>
    </li>
  );
};
